import { useQuestion } from "@/store/question.context";
import { AnswerMode, ChoiceType } from "@/types/questionnaries";
import { FC } from "react";
import AllRequiredChoiceList from "./all-required-choice-list";
import MultipleChoiceList from "./multiple-choice-list";
import SingleChoiceList from "./single-choice-list";

type RootChoiceListProps = {
  onValueChange?: (value: string | undefined) => void;
  disabled?: boolean;
};

const className = "my-5";

const RootChoiceList: FC<RootChoiceListProps> = ({
  onValueChange,
  disabled,
}) => {
  const { question, choices } = useQuestion();

  if (!question) {
    return null;
  }

  const choice = {
    id: question.id,
    statement:
      question.answerMode === AnswerMode.AllRequired
        ? "Rellena los campos"
        : "Escoge",
    answerMode: question.answerMode,
    choices: choices,
    label: question.statement,
    selected: false,
  };

  if (question.answerMode === AnswerMode.Single) {
    return (
      <SingleChoiceList
        choice={{ ...choice, type: ChoiceType.Composite }}
        level={0}
        onValueChange={onValueChange}
        renderChildren={false}
        className={className}
        disabled={disabled}
      />
    );
  }

  if (question.answerMode === AnswerMode.Multiple) {
    return (
      <MultipleChoiceList
        choice={{ ...choice, type: ChoiceType.Composite }}
        level={0}
        className={className}
        disabled={disabled}
      />
    );
  }

  if (question.answerMode === AnswerMode.AllRequired) {
    return (
      <AllRequiredChoiceList
        choice={{ ...choice, type: ChoiceType.Composite }}
        level={0}
        className={className}
        disabled={disabled}
      />
    );
  }

  return "Invalid question";
};

export default RootChoiceList;
